import { SpaceXxs, SizeBorderWidthMedium, ColorCostcoBlue, SizeBorderWidthThin, ColorGray800, ColorWhite } from "@nxt-costco-com/forge-design-tokens";
import { SWATCH_SIZE_COMPACT, SWATCH_SIZE_FULL } from "../constants.js";
const ButtonContainerStyles = {
  ":focus-visible": {
    outline: `${SizeBorderWidthMedium} solid ${ColorCostcoBlue}`,
    outlineOffset: SizeBorderWidthMedium
  },
  ":hover": {
    boxShadow: `0px 0.5px 2px 0px rgba(0, 0, 0, 0.50)`
  },
  alignItems: "center",
  backgroundColor: `${ColorWhite} !important`,
  // individually specifying border properties so that we can override them in the selected and out of stock states
  borderColor: ColorGray800,
  borderRadius: SpaceXxs,
  borderStyle: "solid",
  borderWidth: SizeBorderWidthThin,
  display: "flex",
  height: SWATCH_SIZE_FULL,
  justifyContent: "center",
  minWidth: SWATCH_SIZE_FULL,
  overflow: "hidden",
  padding: SpaceXxs,
  width: SWATCH_SIZE_FULL
};
const ButtonContainerCompactStyles = {
  height: SWATCH_SIZE_COMPACT,
  minWidth: SWATCH_SIZE_COMPACT,
  width: SWATCH_SIZE_COMPACT
};
const ButtonContainerSelectedStyles = {
  backgroundImage: "none",
  borderColor: ColorCostcoBlue,
  borderStyle: "solid !important",
  // the border should always be solid when selected, no matter what the hover state is
  borderWidth: SizeBorderWidthMedium,
  padding: SpaceXxs
};
const ButtonContainerOutOfStockStyles = {
  "::before": {
    // this whole pseudo-selector is to create the diagonal line through the swatch.
    // using this in place of a rotated-div so that it looks "shark" at all resolutions.
    background: `linear-gradient(to top left,
                rgba(0,0,0,0) 0%,
                rgba(0,0,0,0) calc(50% - 0.8px),
                rgba(0,0,0,1) 50%,
                rgba(0,0,0,0) calc(50% + 0.8px),
                rgba(0,0,0,0) 100%)`,
    content: "''",
    height: "100%",
    left: 0,
    position: "absolute",
    top: 0,
    width: "100%",
    zIndex: 1
  },
  // inline SVG was generated using https://kovart.github.io/dashed-border-generator/
  // specifications have been taken from Figma
  backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%235F5F5FFF' stroke-width='3' stroke-dasharray='4%2c8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
  borderStyle: "none"
};
const swatchStyles = {
  boxSizing: "content-box",
  padding: "0"
};
export {
  ButtonContainerCompactStyles,
  ButtonContainerOutOfStockStyles,
  ButtonContainerSelectedStyles,
  ButtonContainerStyles,
  swatchStyles
};
